import React from 'react';
import styles from './editorbutton.module.scss';
interface EditorButtonProps {
  type: 'Update' | 'Cancel';
  onClick: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
}
const EditorButton: React.FC<EditorButtonProps> = ({
  type,
  onClick,
  children
}) => {
  return (
    <button
      type="button"
      onClick={onClick}
      className={`${styles.editorButton} ${
        type === 'Update' ? styles.updateButton : styles.cancelButton
      }`}
    >
      {children}
    </button>
  );
};

export default EditorButton;
